// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: qheaGatNdWNWjNomb854R4
// Component: X4-YYNiLVB
import * as React from "react"
import { Link } from "gatsby"
import * as p from "@plasmicapp/react-web"
import * as ph from "@plasmicapp/host"
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
} from "@plasmicapp/react-web"
import Button from "../../Button" // plasmic-import: PYZjcqsUjd1/component
import TextInput from "../../TextInput" // plasmic-import: YbV5jYR7AgmH/component
import { useScreenVariants as useScreenVariantsdrDuv2SCfUGy4Z } from "./PlasmicGlobalVariant__Screen" // plasmic-import: DrDUV2sCfUGy4Z/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css"
import * as projectcss from "./plasmic_dork_squad.module.css" // plasmic-import: qheaGatNdWNWjNomb854R4/projectcss
import * as sty from "./PlasmicMainLandingPage.module.css" // plasmic-import: X4-YYNiLVB/css
import IconIcon from "./icons/PlasmicIcon__Icon" // plasmic-import: U5di6eDCbmGOfi/icon
import AngleRightsvgIcon from "./icons/PlasmicIcon__AngleRightsvg" // plasmic-import: MmeiDK0KUGyg/icon
import Icon4Icon from "./icons/PlasmicIcon__Icon4" // plasmic-import: LdeL9VuZTXfp/icon
import Icon5Icon from "./icons/PlasmicIcon__Icon5" // plasmic-import: _05ehYFFTKPi/icon
import Icon28Icon from "./icons/PlasmicIcon__Icon28" // plasmic-import: 2aoRQUiLmIhu/icon
import dorkSquadLogosvgWnQb1DIoB from "./images/dorkSquadLogosvg.svg" // plasmic-import: wnQb1DIoB/picture

export const PlasmicMainLandingPage__VariantProps = new Array()

export const PlasmicMainLandingPage__ArgProps = new Array("mail")

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn())

const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    await promise
  })

export function Head() {
  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <title key="title">{PlasmicMainLandingPage.pageMetadata.title}</title>
      <meta
        key="og:title"
        property="og:title"
        content={PlasmicMainLandingPage.pageMetadata.title}
      />

      <meta
        key="twitter:title"
        name="twitter:title"
        content={PlasmicMainLandingPage.pageMetadata.title}
      />

      <meta
        key="description"
        name="description"
        content={PlasmicMainLandingPage.pageMetadata.description}
      />

      <meta
        key="og:description"
        property="og:description"
        content={PlasmicMainLandingPage.pageMetadata.description}
      />

      <meta
        key="twitter:description"
        name="twitter:description"
        content={PlasmicMainLandingPage.pageMetadata.description}
      />

      <meta
        key="og:image"
        property="og:image"
        content={PlasmicMainLandingPage.pageMetadata.ogImageSrc}
      />

      <meta
        key="twitter:image"
        name="twitter:image"
        content={PlasmicMainLandingPage.pageMetadata.ogImageSrc}
      />
    </>
  )
}

function PlasmicMainLandingPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props
  const $ctx = ph.useDataEnv?.() || {}
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          mail: "mailto:info@dorksquad.org",
        },

        props.args
      ),

    [props.args]
  )

  const $props = {
    ...args,
    ...variants,
  }

  const currentUser = p.useCurrentUser?.() || {}
  const [$queries, setDollarQueries] = React.useState({})
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsdrDuv2SCfUGy4Z(),
  })

  return (
    <React.Fragment>
      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          {(
            hasVariant(globalVariants, "screen", "mobileOnly") ? true : true
          ) ? (
            <p.Stack
              as={"div"}
              data-plasmic-name={"header"}
              data-plasmic-override={overrides.header}
              hasGap={true}
              className={classNames(projectcss.all, sty.header)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__epABw)}
              >
                <div
                  className={classNames(projectcss.all, sty.freeBox___99D9U)}
                >
                  <p.PlasmicImg
                    data-plasmic-name={"img"}
                    data-plasmic-override={overrides.img}
                    alt={""}
                    className={classNames(sty.img)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={
                      hasVariant(globalVariants, "screen", "mobileOnly")
                        ? "180px"
                        : "100px"
                    }
                    loading={"lazy"}
                    src={{
                      src: dorkSquadLogosvgWnQb1DIoB,
                      fullWidth: 208,
                      fullHeight: 150,
                      aspectRatio: 1.385768,
                    }}
                  />
                </div>

                {false ? (
                  <div
                    className={classNames(projectcss.all, sty.freeBox__aMrO)}
                  >
                    <button
                      className={classNames(
                        projectcss.all,
                        projectcss.button,
                        projectcss.__wab_text,
                        sty.button__jIn7K
                      )}
                    >
                      {"Sign up"}
                    </button>

                    <p.Stack
                      as={p.PlasmicLink}
                      hasGap={true}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__leZgs
                      )}
                      component={Link}
                      platform={"gatsby"}
                    >
                      {false ? (
                        <IconIcon
                          className={classNames(projectcss.all, sty.svg__ljYyU)}
                          role={"img"}
                        />
                      ) : null}

                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__uhmg1
                        )}
                      >
                        {"Log in"}
                      </div>

                      {false ? (
                        <IconIcon
                          className={classNames(projectcss.all, sty.svg__xEciV)}
                          role={"img"}
                        />
                      ) : null}
                    </p.Stack>
                  </div>
                ) : null}
              </p.Stack>
            </p.Stack>
          ) : null}

          <div
            data-plasmic-name={"groupPicture"}
            data-plasmic-override={overrides.groupPicture}
            className={classNames(projectcss.all, sty.groupPicture)}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"foreground2"}
              data-plasmic-override={overrides.foreground2}
              hasGap={true}
              className={classNames(projectcss.all, sty.foreground2)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__uHd4P)}
              >
                <h1
                  data-plasmic-name={"h1"}
                  data-plasmic-override={overrides.h1}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.h1
                  )}
                >
                  {"This page is under construction"}
                </h1>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__tHq0Y
                  )}
                >
                  {"Please return at a later time!"}
                </div>

                <Button
                  className={classNames("__wab_instance", sty.button__r9IsS)}
                  color={"dorkBlue"}
                  link={`/portfolio`}
                >
                  <p.PlasmicLink
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.link__eIk7
                    )}
                    component={Link}
                    href={`/portfolio`}
                    platform={"gatsby"}
                  >
                    {"Go back to active page"}
                  </p.PlasmicLink>
                </Button>
              </p.Stack>
            </p.Stack>
          </div>

          {true ? (
            <p.Stack
              as={"div"}
              data-plasmic-name={"whatWeStandFor"}
              data-plasmic-override={overrides.whatWeStandFor}
              hasGap={true}
              className={classNames(projectcss.all, sty.whatWeStandFor)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__kMpOm)}
              >
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__aCrYs)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__hePgh)}
                  />
                </p.Stack>
              </p.Stack>
            </p.Stack>
          ) : null}
          {true ? (
            <div
              data-plasmic-name={"recruting"}
              data-plasmic-override={overrides.recruting}
              className={classNames(projectcss.all, sty.recruting)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__xChfp)}>
                <div className={classNames(projectcss.all, sty.columns__x6G1K)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column__mxNht)}
                  />

                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column__l1A1U)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___0Aiaj
                      )}
                      loading={"lazy"}
                    />
                  </p.Stack>
                </div>
              </div>
            </div>
          ) : null}
          {true ? (
            <div
              data-plasmic-name={"allCustomAssets"}
              data-plasmic-override={overrides.allCustomAssets}
              className={classNames(projectcss.all, sty.allCustomAssets)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__i2TZ)}>
                <div className={classNames(projectcss.all, sty.columns__sucTt)}>
                  {(
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? true
                      : true
                  ) ? (
                    <div
                      className={classNames(projectcss.all, sty.column__fOsfq)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__cguh1
                        )}
                        loading={"lazy"}
                      />
                    </div>
                  ) : null}

                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column__w8H4)}
                  />
                </div>
              </div>
            </div>
          ) : null}
          {true ? (
            <div
              data-plasmic-name={"contactUs"}
              data-plasmic-override={overrides.contactUs}
              className={classNames(projectcss.all, sty.contactUs)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__eI5L7)}>
                <div className={classNames(projectcss.all, sty.columns__mDXhI)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.column__sh6Gw)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__hZe6P)}
                    />
                  </p.Stack>

                  <div
                    className={classNames(projectcss.all, sty.column__awYhc)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__pI109)}
                      loading={"lazy"}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {true ? (
            <div
              data-plasmic-name={"reviews"}
              data-plasmic-override={overrides.reviews}
              className={classNames(projectcss.all, sty.reviews)}
            />
          ) : null}
          {(
            hasVariant(globalVariants, "screen", "mobileOnly") ? true : true
          ) ? (
            <p.Stack
              as={"div"}
              data-plasmic-name={"footBar"}
              data-plasmic-override={overrides.footBar}
              hasGap={true}
              className={classNames(projectcss.all, sty.footBar)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__xhiqW)}
              >
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__zewwu)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__x4CJ2)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__dtKdy
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "mobileOnly")
                        ? "Contact us\n"
                        : "Contact us\n"}
                    </div>

                    <p.PlasmicLink
                      data-plasmic-name={"openMailapp"}
                      data-plasmic-override={overrides.openMailapp}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.openMailapp,
                        ""
                      )}
                      component={Link}
                      href={"mailto:info@dorksquad.org"}
                      platform={"gatsby"}
                      target={"_blank"}
                      title={"Open mail"}
                    >
                      <p.PlasmicLink
                        data-plasmic-name={"mailtoinfodorksquadorg"}
                        data-plasmic-override={overrides.mailtoinfodorksquadorg}
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          sty.mailtoinfodorksquadorg
                        )}
                        component={Link}
                        href={args.mail}
                        platform={"gatsby"}
                        target={"_blank"}
                      >
                        {"info@dorksquad.org"}
                      </p.PlasmicLink>
                    </p.PlasmicLink>
                  </div>
                </p.Stack>

                {false ? (
                  <div
                    className={classNames(projectcss.all, sty.freeBox__uYg4I)}
                  >
                    <button
                      className={classNames(
                        projectcss.all,
                        projectcss.button,
                        projectcss.__wab_text,
                        sty.button__emG3U
                      )}
                    >
                      {"Sign up"}
                    </button>

                    <p.Stack
                      as={p.PlasmicLink}
                      hasGap={true}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__r0OQ
                      )}
                      component={Link}
                      platform={"gatsby"}
                    >
                      {false ? (
                        <IconIcon
                          className={classNames(projectcss.all, sty.svg__q7RMr)}
                          role={"img"}
                        />
                      ) : null}

                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___6L8Ea
                        )}
                      >
                        {"Log in"}
                      </div>

                      {false ? (
                        <IconIcon
                          className={classNames(projectcss.all, sty.svg__vAcaq)}
                          role={"img"}
                        />
                      ) : null}
                    </p.Stack>
                  </div>
                ) : null}
              </p.Stack>

              {true ? (
                <div
                  className={classNames(projectcss.all, sty.freeBox___5XjQn)}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__vyAqy)}
                  >
                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.freeBox__r65O4)}
                    >
                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__dE6H
                        )}
                      >
                        <p.Stack
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__g13L7
                          )}
                        >
                          <p.Stack
                            as={"div"}
                            hasGap={true}
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__wxsQu
                            )}
                          >
                            <p.Stack
                              as={p.PlasmicLink}
                              hasGap={true}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                sty.link__fo94C
                              )}
                              component={Link}
                              platform={"gatsby"}
                            >
                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__c64Jy
                                  )}
                                  role={"img"}
                                />
                              ) : null}
                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__cyPxw
                                  )}
                                  role={"img"}
                                />
                              ) : null}
                            </p.Stack>

                            <p.Stack
                              as={p.PlasmicLink}
                              hasGap={true}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                sty.link__rRgr6
                              )}
                              component={Link}
                              platform={"gatsby"}
                            >
                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__gw1Zq
                                  )}
                                  role={"img"}
                                />
                              ) : null}
                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__eiolQ
                                  )}
                                  role={"img"}
                                />
                              ) : null}
                            </p.Stack>

                            <p.Stack
                              as={p.PlasmicLink}
                              hasGap={true}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                sty.link__b6IB
                              )}
                              component={Link}
                              platform={"gatsby"}
                            >
                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__yaGqV
                                  )}
                                  role={"img"}
                                />
                              ) : null}
                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__q8Cxa
                                  )}
                                  role={"img"}
                                />
                              ) : null}
                            </p.Stack>
                          </p.Stack>
                        </p.Stack>
                      </p.Stack>
                    </p.Stack>
                  </p.Stack>
                </div>
              ) : null}
            </p.Stack>
          ) : null}
          {true ? (
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox___3GUbk)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox___16MxV)}
              >
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__f33Bt)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__lwESu)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__wyilZ
                      )}
                    >
                      {"Contact us\n"}
                    </div>

                    <p.PlasmicLink
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        sty.link___2Jbk2
                      )}
                      component={Link}
                      platform={"gatsby"}
                    >
                      {"(555) 555-5555"}
                    </p.PlasmicLink>

                    <p.PlasmicLink
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        sty.link__t6PDh
                      )}
                      component={Link}
                      platform={"gatsby"}
                    >
                      {"support@example.com"}
                    </p.PlasmicLink>
                  </div>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__vijNn)}
                >
                  <p.PlasmicLink
                    data-plasmic-name={"_"}
                    data-plasmic-override={overrides._}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty._
                    )}
                    component={Link}
                    href={"#"}
                    platform={"gatsby"}
                  >
                    {"Shop"}
                  </p.PlasmicLink>

                  <p.PlasmicLink
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.link___2JyQx
                    )}
                    component={Link}
                    platform={"gatsby"}
                  >
                    {"The Academy"}
                  </p.PlasmicLink>

                  <p.PlasmicLink
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.link___2LyNg
                    )}
                    component={Link}
                    platform={"gatsby"}
                  >
                    {"About"}
                  </p.PlasmicLink>

                  <p.PlasmicLink
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.link__vVt01
                    )}
                    component={Link}
                    platform={"gatsby"}
                  >
                    {"Help"}
                  </p.PlasmicLink>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__lfj67)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__tKp03
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "Email newsletter"
                      : "Email newsletter"}
                  </div>

                  <div
                    className={classNames(projectcss.all, sty.freeBox__gQydp)}
                  >
                    <TextInput
                      data-plasmic-name={"textInput"}
                      data-plasmic-override={overrides.textInput}
                      className={classNames("__wab_instance", sty.textInput)}
                      endIcon={
                        <Button
                          className={classNames(
                            "__wab_instance",
                            sty.button__f4Xb
                          )}
                        >
                          <AngleRightsvgIcon
                            className={classNames(
                              projectcss.all,
                              sty.svg__y2Yhr
                            )}
                            role={"img"}
                          />
                        </Button>
                      }
                      placeholder={"E-mail"}
                      showEndIcon={true}
                    />
                  </div>
                </p.Stack>

                {(
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? true
                    : true
                ) ? (
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__fgaNw)}
                  >
                    <p.Stack
                      as={p.PlasmicLink}
                      hasGap={true}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__hZl8N
                      )}
                      component={Link}
                      platform={"gatsby"}
                    >
                      {false ? (
                        <IconIcon
                          className={classNames(projectcss.all, sty.svg__sqCs)}
                          role={"img"}
                        />
                      ) : null}

                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__wG4U5
                        )}
                      >
                        <Icon4Icon
                          className={classNames(projectcss.all, sty.svg__zxlTf)}
                          role={"img"}
                        />

                        <Icon5Icon
                          className={classNames(projectcss.all, sty.svg__iSr34)}
                          role={"img"}
                        />

                        <Icon28Icon
                          className={classNames(projectcss.all, sty.svg__wwal2)}
                          role={"img"}
                        />
                      </p.Stack>

                      {false ? (
                        <IconIcon
                          className={classNames(projectcss.all, sty.svg__j7Wy4)}
                          role={"img"}
                        />
                      ) : null}
                    </p.Stack>
                  </p.Stack>
                ) : null}
                {false ? (
                  <div
                    className={classNames(projectcss.all, sty.freeBox___1VG7V)}
                  >
                    <button
                      className={classNames(
                        projectcss.all,
                        projectcss.button,
                        projectcss.__wab_text,
                        sty.button__fs2LS
                      )}
                    >
                      {"Sign up"}
                    </button>

                    <p.Stack
                      as={p.PlasmicLink}
                      hasGap={true}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.link__oDvsi
                      )}
                      component={Link}
                      platform={"gatsby"}
                    >
                      {false ? (
                        <IconIcon
                          className={classNames(
                            projectcss.all,
                            sty.svg___5QYee
                          )}
                          role={"img"}
                        />
                      ) : null}

                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__niVxx
                        )}
                      >
                        {"Log in"}
                      </div>

                      {false ? (
                        <IconIcon
                          className={classNames(projectcss.all, sty.svg__j4IlW)}
                          role={"img"}
                        />
                      ) : null}
                    </p.Stack>
                  </div>
                ) : null}
              </p.Stack>

              {true ? (
                <div className={classNames(projectcss.all, sty.freeBox__hcqLv)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__b6UhH)}
                  >
                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.freeBox__bajPa)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__bq60T
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__oYlmJ
                          )}
                        >
                          {
                            "(c) Company. All rights reserved. This site proudly built with"
                          }
                        </div>

                        <p.PlasmicLink
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            projectcss.__wab_text,
                            sty.link__lM84
                          )}
                          component={Link}
                          platform={"gatsby"}
                        >
                          {" Plasmic"}
                        </p.PlasmicLink>
                      </div>
                    </p.Stack>

                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___1L9Rz
                      )}
                    >
                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(
                          projectcss.all,
                          sty.freeBox___2P2Dz
                        )}
                      >
                        <p.Stack
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__wAe58
                          )}
                        >
                          <p.Stack
                            as={"div"}
                            hasGap={true}
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___9LFtl
                            )}
                          >
                            <p.Stack
                              as={p.PlasmicLink}
                              hasGap={true}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                sty.link__ccwIy
                              )}
                              component={Link}
                              platform={"gatsby"}
                            >
                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__nfRZu
                                  )}
                                  role={"img"}
                                />
                              ) : null}

                              <p.PlasmicLink
                                className={classNames(
                                  projectcss.all,
                                  projectcss.a,
                                  projectcss.__wab_text,
                                  sty.link__iKdEd
                                )}
                                component={Link}
                                platform={"gatsby"}
                              >
                                {"shop"}
                              </p.PlasmicLink>

                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__moeF
                                  )}
                                  role={"img"}
                                />
                              ) : null}
                            </p.Stack>

                            <p.Stack
                              as={p.PlasmicLink}
                              hasGap={true}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                sty.link__mnjbv
                              )}
                              component={Link}
                              platform={"gatsby"}
                            >
                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg___8BjE
                                  )}
                                  role={"img"}
                                />
                              ) : null}

                              <p.PlasmicLink
                                className={classNames(
                                  projectcss.all,
                                  projectcss.a,
                                  projectcss.__wab_text,
                                  sty.link__zv8FM
                                )}
                                component={Link}
                                platform={"gatsby"}
                              >
                                {"The Academy"}
                              </p.PlasmicLink>

                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__pqcJ
                                  )}
                                  role={"img"}
                                />
                              ) : null}
                            </p.Stack>

                            <p.Stack
                              as={p.PlasmicLink}
                              hasGap={true}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                sty.link__e5FVh
                              )}
                              component={Link}
                              platform={"gatsby"}
                            >
                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__cxilj
                                  )}
                                  role={"img"}
                                />
                              ) : null}

                              <p.PlasmicLink
                                className={classNames(
                                  projectcss.all,
                                  projectcss.a,
                                  projectcss.__wab_text,
                                  sty.link__coea
                                )}
                                component={Link}
                                platform={"gatsby"}
                              >
                                {"About"}
                              </p.PlasmicLink>

                              {false ? (
                                <IconIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__s5Dth
                                  )}
                                  role={"img"}
                                />
                              ) : null}
                            </p.Stack>
                          </p.Stack>
                        </p.Stack>
                      </p.Stack>
                    </p.Stack>
                  </p.Stack>
                </div>
              ) : null}
            </p.Stack>
          ) : null}
        </p.Stack>
      </div>
    </React.Fragment>
  )
}

const PlasmicDescendants = {
  root: [
    "root",
    "header",
    "img",
    "groupPicture",
    "foreground2",
    "h1",
    "whatWeStandFor",
    "recruting",
    "allCustomAssets",
    "contactUs",
    "reviews",
    "footBar",
    "openMailapp",
    "mailtoinfodorksquadorg",
    "_",
    "textInput",
    "textbox",
  ],

  header: ["header", "img"],
  img: ["img"],
  groupPicture: ["groupPicture", "foreground2", "h1"],
  foreground2: ["foreground2", "h1"],
  h1: ["h1"],
  whatWeStandFor: ["whatWeStandFor"],
  recruting: ["recruting"],
  allCustomAssets: ["allCustomAssets"],
  contactUs: ["contactUs"],
  reviews: ["reviews"],
  footBar: ["footBar", "openMailapp", "mailtoinfodorksquadorg"],
  openMailapp: ["openMailapp", "mailtoinfodorksquadorg"],
  mailtoinfodorksquadorg: ["mailtoinfodorksquadorg"],
  _: ["_"],
  textInput: ["textInput", "textbox"],
}

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicMainLandingPage__ArgProps,
          internalVariantPropNames: PlasmicMainLandingPage__VariantProps,
        }),

      [props, nodeName]
    )

    return PlasmicMainLandingPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    })
  }
  if (nodeName === "root") {
    func.displayName = "PlasmicMainLandingPage"
  } else {
    func.displayName = `PlasmicMainLandingPage.${nodeName}`
  }
  return func
}

export const PlasmicMainLandingPage = Object.assign(
  // Top-level PlasmicMainLandingPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    img: makeNodeComponent("img"),
    groupPicture: makeNodeComponent("groupPicture"),
    foreground2: makeNodeComponent("foreground2"),
    h1: makeNodeComponent("h1"),
    whatWeStandFor: makeNodeComponent("whatWeStandFor"),
    recruting: makeNodeComponent("recruting"),
    allCustomAssets: makeNodeComponent("allCustomAssets"),
    contactUs: makeNodeComponent("contactUs"),
    reviews: makeNodeComponent("reviews"),
    footBar: makeNodeComponent("footBar"),
    openMailapp: makeNodeComponent("openMailapp"),
    mailtoinfodorksquadorg: makeNodeComponent("mailtoinfodorksquadorg"),
    _: makeNodeComponent("_"),
    textInput: makeNodeComponent("textInput"),
    // Metadata about props expected for PlasmicMainLandingPage
    internalVariantProps: PlasmicMainLandingPage__VariantProps,
    internalArgProps: PlasmicMainLandingPage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Under construction",
      description: "Construction signs",
      ogImageSrc:
        "https://site-assets.plasmic.app/37235caf5abb4b82502f1e0f51b0163b.jpg",
      canonical: "",
    },
  }
)

export default PlasmicMainLandingPage
/* prettier-ignore-end */
